import { i18n } from '../i18n/translate';

export const reactifiPageTitle = (title, prefix = 'Foundry - %s') => {
  /* i18next-extract-disable-next-line */
  document.title = i18n.t(prefix, { postProcess: 'sprintf', sprintf: [title] });
};
